import { axios, BaseApiUrl} from '../../axios_config';


//查询上架报表
export const getPutOnStockTaskAsync = params => {
    return axios.post(`${BaseApiUrl}/TFPutOnStock/GetPutOnStockTaskAsync`, params);
};

//导出上架
export const exportPutOnStockAsyncOut = `${BaseApiUrl}/TFPutOnStock/PutOnStockAsyncOut`;

//查询仓库库位
export const getWarehouseLocationByWarehouseId = params => {
    return axios.get(`${BaseApiUrl}/WarehouseLocation/GetWarehouseLocationByWarehouseId`, { params: params });
};

//上架
export const insertTFPutOnStock = params => {
    return axios.post(`${BaseApiUrl}/TFPutOnStock/InsertTFPutOnStock`, params);
};


//查询库存
export const getTemporaryStorageTaskAsync = params => {
    return axios.post(`${BaseApiUrl}/TFPutOnStock/GetTemporaryStorageTaskAsync`, params);
};

//导出库存
export const exportTemporaryStorageAsyncOut= `${BaseApiUrl}/TFPutOnStock/TemporaryStorageAsyncOut`;

//导出SKU库存
export const exportTemporarySKUStorageAsyncOut= `${BaseApiUrl}/TFPutOnStock/TemporarySKUStorageAsyncOut`;

//导出箱子明细
export const exportTemporaryBoxStorageAsyncOut= `${BaseApiUrl}/TFPutOnStock/TemporaryBoxStorageAsyncOut`;
